import React from 'react'
import useAppContext from '../../hook/useAppContext'
import Header from '../../components/header/Header'
import TopContent from '../top/TopContent'
import MainContent from '../content/MainContent'

const Main = () => {

      const {user} = useAppContext()

      if(user.length === 0){
            return
      }

      return (
            <div className="main_content">
                  <Header />
                  <div className="container">
                        <TopContent />
                        <MainContent />
                  </div> 
            </div>
      )
}

export default Main
